import { OPERATOR_SCOPED_ID } from "../../../shared/constants/operator.constants";

export type ContactSuccessAction = "added" | "updated" | "removed";

const CONTACT_SUCCESS_VERBS: Record<ContactSuccessAction, string> = {
  added: "is added",
  updated: "is updated",
  removed: "is removed",
};

export function parseBookingId(rowId: string): number | null {
  const parsed = parseInt(rowId, 10);
  return Number.isFinite(parsed) ? parsed : null;
}

export function resolveOperatorIdFromListRow(
  listRow: { operatorId?: string } | null,
): number {
  const fromListRow = listRow?.operatorId ? parseInt(listRow.operatorId, 10) : NaN;
  return Number.isFinite(fromListRow) ? fromListRow : OPERATOR_SCOPED_ID;
}

export function resolveCustomerOperatorId(
  customer: { operatorId?: number } | null | undefined,
): number {
  if (typeof customer?.operatorId === "number" && customer.operatorId > 0) {
    return customer.operatorId;
  }
  return OPERATOR_SCOPED_ID;
}

export function formatContactSuccessMessage(name: string, action: ContactSuccessAction): string {
  const displayName = name.trim() || "Contact";
  return `${displayName} ${CONTACT_SUCCESS_VERBS[action]} successfully.`;
}

export function formatBulkContactDeleteDescription(
  deletedContactNames: string[],
  count: number,
): string {
  if (deletedContactNames.length === 1) {
    return formatContactSuccessMessage(deletedContactNames[0], "removed");
  }
  if (deletedContactNames.length > 1) {
    return `${deletedContactNames.join(", ")} are removed successfully.`;
  }
  return count === 1
    ? formatContactSuccessMessage("Contact", "removed")
    : `${count} contacts are removed successfully.`;
}

export function formatBulkContactRestoreDescription(
  deletedContactNames: string[],
  count: number,
): string {
  if (deletedContactNames.length === 1) {
    return `${deletedContactNames[0]} is restored successfully.`;
  }
  if (deletedContactNames.length > 1) {
    return `${deletedContactNames.join(", ")} are restored successfully.`;
  }
  return count === 1
    ? "Contact restored successfully."
    : `${count} contacts restored successfully.`;
}

export function formatLocationDisplayName(locationName: string, locationId: number): string {
  return locationName.trim() || `Location ${locationId}`;
}

export function formatCustomerDisplayName(name: string): string {
  return name.trim() || "this customer";
}
